// Tiny pub/sub bus so the autonomous Coach can trigger a reversible UI-STATE
// action on a page (e.g. apply/undo a report filter) without prop-drilling.
// Pages subscribe; the Coach dispatches after the user confirms. No data mutation.
const subs = new Set();

export function onCoachAction(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}

export function dispatchCoachAction(action) {
  let handled = false;
  subs.forEach((fn) => { if (fn(action) === true) handled = true; });
  return handled;
}
